<template>
  <div class="w-full">
    <div>
      <SmartTitle
        class="form-list__title mb-2 mt-1 mr-2"
        style="margin-left: 5px!important"
        weight="medium"
        heading="1"
      >
        Gestão
      </SmartTitle>
    </div>
    <div>
      <FilterSale ref="filterSale" @searchWithFilter="search" />
    </div>
    <div class="flex justify-end mb-2">
      <SmartButton @click="download" class="mr-2 inline-flex" style="z-index: 1">
        <SmartIcon name="upload" :size="2" />
        Exportar Arquivo
      </SmartButton>
    </div>
    <vue-scroll :ops="ops" v-if="!loading">
      <VDataTable
        id="sale-table"
        :headers="headers"
        :items="sales"
        hide-actions
        :must-sort="true"
        @update:pagination="sort"
        :pagination="defaultPagination"
        class="my-4"
        :class="{ loading: false }"
      >
        <template slot="items" slot-scope="props">
          <td>{{ props.item.date }}</td>
          <td>{{ props.item.registration }}</td>
          <td>{{ props.item.name }}</td>
          <td>{{ props.item.place }}</td>
          <td>{{ props.item.type }}</td>
          <td>{{ props.item.product }}</td>
          <td>{{ props.item.c6bank }}</td>
          <td>{{ props.item.msisdn }}</td>
          <td class="view-icon">
            <label
              @click="showInfo(props.item.id)"
              class="flex flex-row align-center justify-center cursor-pointer"
            >
              <SmartIcon :size="2" name="view" class="mr-1-2" />
            </label>
          </td>
        </template>
      </VDataTable>
    </vue-scroll>
    <SmartCard class="mt-1 p-3" v-else>
      <SmartSkeletonLoading :items="11" :height="4" />
    </SmartCard>
    <div class="flex justify-center mt-4">
      <v-pagination
        v-if="currentPage"
        v-model="pagination.page"
        @input="changePage"
        :length="length"
        :value="currentPage"
        :total-visible="7"
        circle
      />
    </div>
    <div>
      <SmartDrawer @close="closeDrawer" :show="showDrawer">
        <template v-slot:header>
          <SmartTitle class="text-brand-secondary" weight="regular">
            {{ showEdit ? 'Editar Venda' : 'Detalhe de Venda' }}
          </SmartTitle>
        </template>
        <InfoSale
          v-if="!showEdit && sale"
          :sale="sale"
          @editSale="showEdit = true"
          @reload="reload"
        />
        <EditSale v-if="showEdit" :sale="sale" @cancel="closeDrawer" @reload="reload" />
      </SmartDrawer>
      <SmartModal v-if="modal" v-bind="modal" @close="modal = null">
        {{ modal.text }}
      </SmartModal>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import moment from 'moment';
import { downloadXlsFile, getBlobError } from 'utils/blob';
import vuescroll from 'vuescroll';

export default {
  name: 'List',
  components: {
    FilterSale: () => import('./FilterSale.vue'),
    InfoSale: () => import('./InfoSale'),
    EditSale: () => import('./EditSale'),
    vuescroll
  },
  data() {
    return {
      ops: {
        bar: {
          background: '#000',
          opacity: 0.2,
          keepShow: true
        }
      },
      modal: null,
      size: 10,
      sale: null,
      registration: '',
      loading: false,
      showDrawer: false,
      showEdit: false,
      pagination: {
        rowsPerPage: 10,
        page: 1
      },
      selectedRegistration: null,
      defaultPagination: {
        descending: true,
        rowsPerPage: 10,
        page: 1,
        sortBy: 'sale_date',
        totalItems: 0
      },
      headers: [
        { text: 'Data', value: 'sale_date', sortable: true },
        { text: 'Matrícula', value: 'user_registration', sortable: true },
        { text: 'Vendedor', value: 'user_id', sortable: true },
        { text: 'Loja', value: `place.name`, sortable: true },
        { text: 'Tipo', value: 'sale_type', sortable: true },
        { text: 'Produto', value: 'sale_segment', sortable: true },
        { text: 'C6 Bank', value: 'c6bank', sortable: true },
        { text: 'Linha', value: 'sale_msisdn', sortable: true },
        { text: 'Detalhes', value: 'actions', sortable: true }
      ],
      currentSort: {
        order: 'asc',
        sort: 'name'
      }
    };
  },
  filters: {
    tell(value) {
      return value && value.replace(/^(\d{2})(\d{4,5})(\d{4})$/, '($1) $2-$3');
    }
  },
  methods: {
    ...mapActions({
      fetchSalesManagement: 'saleManagement/fetchSalesManagement',
      downloadSale: 'saleManagement/downloadSale'
    }),
    async sort(sortable) {
      let newSort = {
        order: sortable.descending ? 'desc' : 'asc',
        sort: sortable.sortBy
      };
      let filterSaleFilters = this.$refs.filterSale && this.$refs.filterSale.filterSerialized;
      if (this.selectedRegistration) {
        const serializedRegistration = `registration=${this.selectedRegistration}`;

        filterSaleFilters += filterSaleFilters
          ? `&${serializedRegistration}`
          : serializedRegistration;
      }

      this.defaultPagination = JSON.parse(JSON.stringify(sortable));

      if (JSON.stringify(newSort) !== JSON.stringify(this.currentSort)) {
        this.currentSort = newSort;
        this.fetchSalesManagement({
          page: this.pagination.page,
          filters: filterSaleFilters,
          sort: this.currentSort
        });
      }
    },
    reload() {
      this.showDrawer = false;
      this.changePage(this.currentPage);
    },
    async download() {
      this.downloadSale(this.$refs.filterSale.filters)
        .then(data => {
          const currentDate = moment().format('YYYYMMDD');
          downloadXlsFile({ filename: currentDate, file: data });
        })
        .catch(error => {
          getBlobError(error).then(result => {
            this.modal = {
              type: 'warning',
              title: 'Ops!',
              icon: 'alert',
              buttonText: 'Cancelar',
              text: JSON.parse(result).message
            };
          });
        });
    },
    changePage(page) {
      let filterSaleFilters = this.$refs.filterSale && this.$refs.filterSale.filterSerialized;
      if (this.selectedRegistration) {
        const serializedRegistration = `registration=${this.selectedRegistration}`;

        filterSaleFilters += filterSaleFilters
          ? `&${serializedRegistration}`
          : serializedRegistration;
      }
      this.loading = true;
      this.fetchSalesManagement({
        page,
        filters: filterSaleFilters,
        sort: this.currentSort
      }).then(() => {
        this.loading = false;
      });
    },
    showInfo(id) {
      const tempSale = this.salesManagement.find(sale => sale.id === id);
      this.sale = {
        id: tempSale.id,
        type: tempSale.type,
        date: tempSale.sale_date,
        product: tempSale.plan && tempSale.plan.segment.name,
        sourcePlan:
          tempSale.source_plan && tempSale.source_plan.name
            ? tempSale.source_plan && tempSale.source_plan.name
            : '',
        plan: tempSale.plan && tempSale.plan.name,
        gadget: tempSale.gadget,
        offer: tempSale.offer,
        category: tempSale.category || '',
        hdc: tempSale.hdc,
        c6bank: tempSale.c6bank,
        iccid: tempSale.iccid,
        msisdn: this.$options.filters.tell(tempSale.msisdn),
        place: tempSale.place.name,
        registration: tempSale.user.registration,
        user: tempSale.user.name,
        source: tempSale.sorce_plan && tempSale.sorce_plan.name,
        socialNetwork: tempSale.social_network,
        price: tempSale.value,
        serialNumber: tempSale.serial_number,
        customerCpf: tempSale.customer_cpf
      };
      this.showDrawer = true;
    },
    closeDrawer() {
      this.showDrawer = false;
      this.sale = null;
      this.showEdit = false;
    },
    search() {
      this.changePage(this.currentPage);
    }
  },
  computed: {
    ...mapGetters({
      salesManagement: 'saleManagement/salesManagement',
      salesPagination: 'saleManagement/pagination',
      usersWithSale: 'user/usersWithSale'
    }),
    length() {
      return this.salesPagination && this.salesPagination.last_page;
    },
    currentPage() {
      return this.salesPagination && this.salesPagination.current_page;
    },
    sales() {
      return (
        (this.salesManagement &&
          this.salesManagement.map(sale => ({
            id: sale.id,
            date: sale.sale_date ? moment(sale.sale_date).format('DD/MM/YYYY') : '-',
            registration:
              sale.user && sale.user.registration ? sale.user && sale.user.registration : '-',
            name: sale.user && sale.user.name ? sale.user && sale.user.name : '-',
            place: sale.place.name ? sale.place.name : '-',
            type: sale.type ? sale.type : '-',
            product:
              sale.plan && sale.plan.segment.name ? sale.plan && sale.plan.segment.name : '-',
            c6bank: sale.c6bank == 1 ? 'Sim' : sale.c6bank == 0 ? 'Não' : '-',
            msisdn: sale.msisdn ? this.$options.filters.tell(sale.msisdn) : '-',
            source: sale.source_plan_name
          }))) ||
        []
      );
    }
  },
  watch: {
    selectedRegistration() {
      this.changePage(this.currentPage);
    }
  },
  async mounted() {
    // await this.changePage(1);
    this.loading = true;
    await this.fetchSalesManagement({ sort: this.currentSort });
    this.loading = false;
  }
};
</script>

<style lang="scss" scoped>
#sale-table td {
  text-overflow: ellipsis;
  max-width: 200px;
  overflow: hidden;
  white-space: nowrap;
  transition: 1s;
}
#sale-table td:hover {
  max-width: 1000px !important;
  transition: 1s;
}
</style>
